module.exports = __webpack_public_path__ + "img/chargingpoint-alert.7921b848.svg";